<template>
  <div class="modal-parent">
    <div
      v-shortkey="['esc']"
      class="modal"
      @shortkey="closeModal"
    >
      <div class="modal_topbar">
        <div class="modal_topbar-title-container">
          <div
            id="title-device-settings-modal"
            class="modal_topbar-title"
          >
            {{ deviceSettingsModalTitle }}
          </div>
          <div
            id="title-device-settings-modal"
            class="modal_topbar__description"
          >
            {{ deviceInfo }}
          </div>
        </div>
        <div class="modal_topbar_action">
          <template v-if="device.isLoading">
            <loader :size="25" />
          </template>
        </div>
        <span
          id="exit-device-settings-modal"
          class="modal_topbar-exit"
          @click="closeModal"
          v-html="closeIcon"
        />
      </div>
      <div class="modal-tabs">
        <template v-for="(tabValue, tabKey) in deviceTabs">
          <div
            :id="tabKey + '-tab'"
            :key="tabValue.label"
            :class="[{ 'modal-tabs__item--active': tabKey === currentTab }, 'modal-tabs__item']"
            @click="setCurrentTab(tabKey)"
          >
            {{ tabValue.label }}
          </div>
        </template>
      </div>
      <component
        :is="currentTabComponent"
        :device="device"
        @submit-wifi="submitWifi"
        @submit-ethernet="submitEthernet"
        @submit-auth-method-settings="submitAuthMethodSettings"
        @cancel="closeModal"
      >
      </component>
    </div>
    <div class="modal-overlay" />
  </div>
</template>

<script>
import feather from 'feather-icons'
import WifiSettings from '@/components/networkSettings/wifiSettings.vue'
import AuthenticationSettings from '@/components/networkSettings/authenticationSettings.vue'
import EthernetSettings from '@/components/networkSettings/ethernetSettings.vue'
import Loader from '@/components/loader.vue'
import moment from 'moment'

export default {
  name: 'NetworkSettings',
  components: {
    WifiSettings,
    EthernetSettings,
    AuthenticationSettings,
    Loader,
  },
  props: ['device'],
  data() {
    return {
      isWifiScreen: false,
      closeIcon: feather.icons.x.toSvg(),
      currentTab: 'ethernet',
      deviceTabs: {},
    }
  },
  computed: {
    currentTabComponent() {
      return this.deviceTabs[this.currentTab].component
    },
    deviceSettingsModalTitle() {
      const _currentTabLabel = this.deviceTabs[this.currentTab].label
      return `Device ${_currentTabLabel} Settings`
    },
    deviceInfo() {
      const maxDeviceNameLength = 13
      const {firmware, parentDevice, telemetryUpdatedAt, network} = this.device
      const {currentIpAddr} = network || {} // Guard against null network
      const deviceName = this.device.name
      const truncatedName
        = deviceName.length >= maxDeviceNameLength
          ? `${deviceName.substring(0, maxDeviceNameLength)}...`
          : deviceName
      let deviceInfo = `${truncatedName} |`

      deviceInfo = this.appendInfo(deviceInfo, 'Mac Address', parentDevice)
      deviceInfo = this.appendInfo(deviceInfo, 'Firmware', firmware)
      deviceInfo = this.appendInfo(deviceInfo, 'Last Known IP', currentIpAddr)
      deviceInfo += this.formatUpdatedAt(telemetryUpdatedAt)

      return deviceInfo.trim() // Trim the trailing '|' if needed
    },
  },
  created() {
    this.deviceTabs = {
      ethernet: {
        label: 'Ethernet',
        component: EthernetSettings,
      },
      wifi: {
        label: 'Wi-Fi',
        component: WifiSettings,
      },
      authMethod: {
        label: 'Authentication Method',
        component: AuthenticationSettings,
      },
    }

    // Only show auth method tab for safes
    if (this.device.type !== 'safe') {
      delete this.deviceTabs.authMethod
    }
  },
  methods: {
    setCurrentTab(tab) {
      this.currentTab = tab
    },
    closeModal() {
      this.$emit('close')
    },
    submitEthernet(device) {
      this.$emit('submit-ethernet', device)
    },
    submitAuthMethodSettings(device) {
      this.$emit('submit-auth-method-settings', device)
    },
    submitWifi(device) {
      this.$emit('submit-wifi', device)
    },
    appendInfo(info, label, value) {
      return value ? `${info} ${label}: ${value} |` : info
    },
    formatUpdatedAt(date) {
      return date ? ` (Last Updated at: ${moment(date).format('ddd. MMM DD YYYY, h:mm a')})` : ''
    },
  },
}
</script>
